import { Region } from '~/lib/ApiModel';
import { IApiClient } from '~/lib/ApiClient';
import { loadAllItems } from '~/lib/helper/PagingHelper';
import { AsyncStore } from './AsyncStore';
import { computed, makeObservable } from 'mobx';

export class RegionsStore extends AsyncStore<Region[]> {
    constructor(apiClient: IApiClient) {
        super(() => loadAllItems((link) => apiClient.getRegions(link)), []);
        makeObservable(this);
    }

    @computed
    get items() {
        return this.item;
    }
}
